import { arange } from 'utils/arange'

/**
 * The number of years that can be simulated to from the current year (excluding current year).
 */
export const NUM_YEARS_ABLE_TO_SIM_TO = 15

export function listYearsToSimTo(): ReadonlyArray<number> {
  const baseYear = new Date().getUTCFullYear()
  return arange(baseYear, baseYear + NUM_YEARS_ABLE_TO_SIM_TO + 1)
}
